import React, { useMemo } from "react";
import moment from "moment";
import {
  ReadOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  AppstoreOutlined,
  ContainerOutlined,
} from "@ant-design/icons";
import { LectureData } from "./LectureTypes";

interface InfoItem {
  id: string;
  label: string;
  value: string | number;
  icon: React.ReactNode;
}

const LectureInfoCard: React.FC<{ lecture?: LectureData }> = ({
  lecture = {},
}) => {
  const className = lecture?.class || "N/A";
  const locationName = lecture?.room || "N/A";
  const subjectName = lecture?.subject || "N/A";
  const batchId = lecture?.batchId ? Number(lecture.batchId) : "N/A";
  const { dateVal, timeVal } = useMemo(() => {
    let formattedDate = "N/A";
    let formattedTime = "N/A";

    if (lecture?.startTime) {
      const startMoment = moment(lecture.startTime);
      if (startMoment.isValid()) {
        formattedDate = startMoment.format("ddd, D MMM YYYY");
        const startTimeStr = startMoment.format("h:mm A");

        if (lecture?.endTime) {
          const endMoment = moment(lecture.endTime);
          if (endMoment.isValid()) {
            formattedTime = `${startTimeStr} – ${endMoment.format("h:mm A")}`;
          } else {
            formattedTime = startTimeStr;
          }
        } else {
          formattedTime = startTimeStr;
        }
      }
    }

    return { dateVal: formattedDate, timeVal: formattedTime };
  }, [lecture?.startTime, lecture?.endTime]);

  const infoItems: InfoItem[] = [
    {
      id: "class",
      label: "CLASS",
      value: className,
      icon: (
        <ReadOutlined
          style={{ fontSize: "16px", color: "var(--primary-text)" }}
        />
      ),
    },
    {
      id: "location",
      label: "LOCATION",
      value: locationName,
      icon: (
        <EnvironmentOutlined
          style={{ fontSize: "16px", color: "var(--primary-text)" }}
        />
      ),
    },
    {
      id: "date",
      label: "DATE",
      value: dateVal,
      icon: (
        <CalendarOutlined
          style={{ fontSize: "16px", color: "var(--primary-text)" }}
        />
      ),
    },
    {
      id: "time",
      label: "TIME",
      value: timeVal,
      icon: (
        <ClockCircleOutlined
          style={{ fontSize: "16px", color: "var(--primary-text)" }}
        />
      ),
    },
    {
      id: "subject",
      label: "SUBJECT",
      value: subjectName,
      icon: (
        <AppstoreOutlined
          style={{ fontSize: "16px", color: "var(--primary-text)" }}
        />
      ),
    },
    {
      id: "batch",
      label: "BATCH",
      value: batchId,
      icon: (
        <ContainerOutlined
          style={{ fontSize: "16px", color: "var(--primary-text)" }}
        />
      ),
    },
  ];

  return (
    <div
      className="lecture-info-card"
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "16px",
        border: "1px solid #e2e8f0",
        boxShadow: "0 1px 3px rgba(0,0,0,0.02)",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "16px 20px",
          fontSize: "11px",
          fontWeight: 700,
          color: "#94a3b8",
          letterSpacing: "0.05em",
          borderBottom: "1px solid #f1f5f9",
        }}
      >
        LECTURE INFORMATION
      </div>

      <div>
        {infoItems.map((item) => (
          <div key={item.id} className="info-card-item">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "14px",
              }}
            >
              <div
                style={{
                  width: "38px",
                  height: "38px",
                  borderRadius: "10px",
                  backgroundColor: "#e6f7f9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {item.icon}
              </div>
              <div>
                <div
                  style={{
                    fontSize: "10px",
                    fontWeight: 700,
                    color: "#94a3b8",
                    letterSpacing: "0.05em",
                  }}
                >
                  {item.label}
                </div>
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: 700,
                    color: "#0f172a",
                    marginTop: "2px",
                  }}
                >
                  {item.value}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LectureInfoCard;
